const Checkbox = ({ isChecked, onChange }) => {
    return (
        <div className="checkbox-wrapper">
            <label>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={onChange}
                />
            </label>
        </div>
    )
}
export default Checkbox
